import React from 'react';
import { useAuth } from '../context';
import { ReportUsageDashboard } from '../components/reportUsage';

const ReportUsagePage = () => {
  const { user } = useAuth();
  return (
    <div className="page-background">
      <ReportUsageDashboard isAdmin={user?.isAdmin || false} />
    </div>
  );
};

export default ReportUsagePage;
